var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumWithCircle4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_3875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.33398,
    y: 3.3335,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    fill: "#7F8283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4884 13.3335V12.1689H7.38151V11.1274C7.54264 10.8403 7.70524 10.5562 7.8693 10.2749C8.03337 9.99072 8.19889 9.70947 8.36589 9.43115C8.53581 9.1499 8.70426 8.87305 8.87126 8.60059C9.04118 8.3252 9.2111 8.0542 9.38102 7.7876C9.55094 7.51807 9.72087 7.25293 9.89079 6.99219H11.7541V11.1055H12.5802V12.1689H11.7541V13.3335H10.4884ZM8.57682 11.1406H10.5148V7.99854H10.4445C10.3215 8.18896 10.1955 8.38379 10.0666 8.58301C9.94059 8.78223 9.81315 8.98584 9.68424 9.19385C9.55827 9.40186 9.43083 9.61133 9.30192 9.82227C9.17594 10.0303 9.05143 10.2397 8.92839 10.4507C8.80827 10.6587 8.69108 10.8652 8.57682 11.0703V11.1406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_3875"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.33398,
    y: 3.3335,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumWithCircle4);
export default __webpack_public_path__ + "static/media/NumWithCircle_4.b1a840a287f99c9fdbdd6dccaacfb70c.svg";
export { ForwardRef as ReactComponent };